// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"FormContent_formContainer__2Lnu9","formTitle":"FormContent_formTitle__2oHCJ"};